import { render, staticRenderFns } from "./labelSystem.vue?vue&type=template&id=58d107b4&scoped=true&"
import script from "./labelSystem.vue?vue&type=script&lang=js&"
export * from "./labelSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d107b4",
  null
  
)

component.options.__file = "labelSystem.vue"
export default component.exports